import { colorPalettes } from 'lego-dist';

const { KineduPalette, MiscPalette } = colorPalettes;

const AppColor = {
  centersScopeCard: '#dc4b78',
  studentsScopeCard: '#33cd3c',
  classroomsScopeCard: '#9139a5',
  topBarTextColor: MiscPalette.white,
  primary: '#0086D8',
  amber: '#F9BA48',
  orange: '#F99848',
  indigo: '#0E3687',
  blueLight: '#E5F2FB',
  green: '#44C94E',
  blue: '#0093DD',
};

export const colors = { ...KineduPalette, ...MiscPalette, ...AppColor };
